import LoadingOverlay from 'common/components/LoadingOverlay'

const phrases = [
  'Preparing your content',
  'Generating ideas',
  'Crafting the perfect content',
  'Searching for that extra bit of awesomeness...',
  'Refining your masterpiece',
  'Finalizing the details',
  "Don't worry, we're almost ready to roll!",
  'Finishing the last touches...',
  'Polishing to perfection',
  "Sorry for the wait, it'll be worth it!",
]

type Props = {
  isLoading: boolean
}

const ContentLoadingOverlay = ({ isLoading }: Props) => {
  return <LoadingOverlay isLoading={isLoading} phrases={phrases} />
}

export default ContentLoadingOverlay
